/* NordPull landing sections: gallery, how-to videos, bundle picker, order ticker, cost tabs. Danish store: Danish labels and number format. */
(function () {
  if (window.__kpLoaded) return;
  window.__kpLoaded = true;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  // Videos that run on their own like moving pictures: muted, looping, inline, no controls.
  function silentLoop(v) {
    v.muted = true;
    v.defaultMuted = true;
    v.loop = true;
    v.autoplay = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('autoplay', '');
    v.removeAttribute('controls');
    play(v);
  }
  // Plays the videos while their container is on screen and pauses them when it scrolls away.
  function playWhileVisible(container, videos) {
    if (!videos.length || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var on = entries[0].isIntersecting;
      each(videos, function (v) { if (on) play(v); else v.pause(); });
    }, { threshold: 0.1 }).observe(container);
  }

  function initGallery(root) {
    var stage = root.querySelector('[data-kp-stage]');
    if (!stage) return;
    var slides = stage.children;
    var thumbs = root.querySelectorAll('[data-kp-thumb]');
    var videos = stage.querySelectorAll('video');
    // Gallery videos keep running while the gallery is on screen, so one is already moving when the customer swipes to it.
    each(videos, function (v) { v.preload = 'auto'; silentLoop(v); });
    function current() { return Math.round(stage.scrollLeft / (stage.clientWidth || 1)); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var c = current();
      each(thumbs, function (t, i) { t.classList.toggle('is-active', i === c); });
      var at = thumbs[c];
      if (at) {
        var row = at.parentNode;
        row.scrollTo({ left: at.offsetLeft - row.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
      }
    }
    var timer;
    stage.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(sync, 80); }, { passive: true });
    each(thumbs, function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('[data-kp-prev]');
    var next = root.querySelector('[data-kp-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    playWhileVisible(stage, videos);
    sync();
  }

  // How-to videos loop silently; tapping a video (or its speaker button) turns its sound on and mutes the others.
  function initHowto(root) {
    var items = root.querySelectorAll('[data-kp-howto]');
    var videos = [];
    function setState(item, v) {
      var btn = item.querySelector('[data-kp-sound]');
      item.classList.toggle('is-unmuted', !v.muted);
      if (btn) {
        btn.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        btn.setAttribute('aria-label', v.muted ? 'Slå lyden til' : 'Slå lyden fra');
      }
    }
    each(items, function (item) {
      var v = item.querySelector('video');
      if (!v) return;
      videos.push(v);
      silentLoop(v);
      setState(item, v);
      item.addEventListener('click', function () {
        var turnOn = v.muted;
        each(items, function (other) {
          var ov = other.querySelector('video');
          if (!ov || ov === v) return;
          ov.muted = true;
          setState(other, ov);
        });
        v.muted = !turnOn;
        play(v);
        setState(item, v);
      });
    });
    var row = root.querySelector('.kp-howto__row');
    if (row) playWhileVisible(row, videos);
  }

  function initBundle(root) {
    var opts = root.querySelectorAll('[data-kp-opt]');
    function update() { each(opts, function (o) { o.classList.toggle('is-checked', o.querySelector('input').checked); }); }
    each(opts, function (o) { o.querySelector('input').addEventListener('change', update); });
    update();
  }

  function initTicker(root) {
    var items = root.querySelectorAll('.kp-ticker__item');
    if (items.length < 2) return;
    var bar = root.querySelector('.kp-ticker__bar span');
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
      if (bar) bar.style.width = ((i + 1) / items.length * 100) + '%';
    }, 3500);
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-kp-count'));
    if (isNaN(target)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = target.toLocaleString('da-DK'); return; }
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / 1100, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString('da-DK');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCost(root) {
    var tabs = root.querySelectorAll('[data-kp-tab]');
    var panels = root.querySelectorAll('[data-kp-panel]');
    function activate(i) {
      each(tabs, function (t, j) { t.classList.toggle('is-active', j === i); t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      each(panels, function (p, j) { p.hidden = j !== i; if (j === i) each(p.querySelectorAll('[data-kp-count]'), countUp); });
    }
    each(tabs, function (t, i) { t.addEventListener('click', function () { activate(i); }); });
    var cta = root.querySelector('[data-kp-scroll]');
    if (cta) cta.addEventListener('click', function () {
      var target = document.querySelector('.kp-bundle') || document.querySelector('.kp-main') || document.querySelector('form[action*="/cart/add"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var open = root.querySelector('[data-kp-panel]:not([hidden])');
        if (open) each(open.querySelectorAll('[data-kp-count]'), countUp);
      }, { threshold: 0.3 });
      io.observe(root);
    }
  }

  function init(scope) {
    each((scope || document).querySelectorAll('[data-kp]'), function (el) {
      if (el.__kpDone) return;
      el.__kpDone = true;
      var type = el.getAttribute('data-kp');
      if (type === 'main') { initGallery(el); initHowto(el); initBundle(el); }
      if (type === 'ticker') initTicker(el);
      if (type === 'cost') initCost(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
